import { PUBLIC_PAGES } from '@belong/constants';
import { IDisplayAddress } from '@belong/types';

export const ADDRESS_CHECK_ANCHOR_ID = 'address-check';
export const ADDRESS_CHECK_HEADING_ID = 'check-your-address-heading';
export const PLAN_SECTION_ANCHOR_ID = 'section-select-a-plan';
export const PLAN_SECTION_HEADING_ID = 'select-a-plan-heading';

/** Post-SQ internet plans page, anchored to the plan selection section. */
export const POST_SQ_PLAN_SUMMARY_ANCHOR = `${PUBLIC_PAGES.NBN_PLANS_SQ}#${PLAN_SECTION_ANCHOR_ID}`;

export const PLAN_SPEED_DISPLAY = {
  '25/5': 'Starter',
  '25/10': 'Starter',
  '50/20s': 'Starter',
  '50/20': 'Standard Plus',
  '100/40': 'Premium',
  '100/20': 'Premium'
};

export type PlanSpeedDisplayKeys = keyof typeof PLAN_SPEED_DISPLAY;

export const parsePlanToDisplay = (planSpeed: PlanSpeedDisplayKeys): string => {
  return `${PLAN_SPEED_DISPLAY[planSpeed]}`;
};

export const getDisplayAddress = (displayAddress: IDisplayAddress): string => {
  const {
    servicePostcode,
    serviceState,
    serviceStreet,
    serviceStreetNumber,
    serviceStreetType = '',
    serviceSubAddressDetails,
    serviceSuburb
  } = displayAddress;
  const trimServiceSubAddressDetails = serviceSubAddressDetails?.trim();
  const prefix = [trimServiceSubAddressDetails, serviceStreetNumber, serviceStreet, serviceStreetType]
    .filter(segment => segment)
    .join(' ');

  const suffix = [serviceSuburb, serviceState, servicePostcode].join(' ');

  return [prefix, suffix].join(', ');
};
